import {take, put} from 'redux-saga/effects';
import {ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED} from '@computerrock/formation-router';
import {efServiceAssignmentTypes} from '@ace-de/eua-entity-types';
import updateServiceAssignment from '../../service-assignments/sagas/updateServiceAssignment';
import updateServiceCase from '../../service-cases/sagas/updateServiceCase';
import * as samsActionTypes from '../samsActionTypes';

/**
 * Update SAMS journey data
 */
const updateSAMSJourneyData = function* updateSAMSJourneyData() {
    while (true) {
        const {payload} = yield take(samsActionTypes.SUBMIT_SAMS_JOURNEY_DATA_FORM);
        const {serviceAssignmentData, serviceCaseData, serviceCaseId, serviceAssignmentLineNo, caseType} = payload;

        yield* updateServiceCase({
            caller: samsActionTypes.SUBMIT_SAMS_JOURNEY_DATA_FORM,
            caseType: caseType,
            serviceCaseId,
            serviceCaseData,
        });

        yield* updateServiceAssignment({
            caller: samsActionTypes.SUBMIT_SAMS_JOURNEY_DATA_FORM,
            assignmentType: efServiceAssignmentTypes.MEDICINE_SHIPMENT,
            serviceAssignmentLineNo,
            serviceCaseId,
            serviceAssignmentData,
        });

        yield put({
            type: ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED,
            payload: {caller: samsActionTypes.SUBMIT_SAMS_JOURNEY_DATA_FORM},
        });
    }
};

export default updateSAMSJourneyData;
